/**
 * Redirects to the login page with error message
 *
 * @param {string} rootURL
 * @param {any} error
 * @param {string} page Default value login
 */
export function navigateWithError(
    rootURL: string,
    error: Error,
    page = 'login'
): void {
    const { message } = error;
    window.history.pushState({}, '', `${rootURL}${page}?error=${message}`);
}
